import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom'; // Make sure Link is imported
import './FacultyListPage.css';

const FacultyListPage = () => {
  const [faculty, setFaculty] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchFaculty = async () => {
      try {
        setLoading(true);
        const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000'; // Fallback for local dev
        const res = await axios.get(`${apiUrl}/api/faculty`);;
        setFaculty(res.data);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching faculty:', err);
        setLoading(false);
      }
    };

    fetchFaculty();
  }, []);

  const filteredFaculty = faculty.filter(prof => {
    const search = searchTerm.toLowerCase();
    return (
      prof.name.toLowerCase().includes(search) ||
      prof.department.toLowerCase().includes(search)
    );
  });

  if (loading) {
    return <div className="loading-spinner">Loading faculty...</div>;
  }

  return (
    <div className="faculty-list-container">
      {/* --- NEW: Header with Button --- */}
      <div className="faculty-list-header">
        <div className="header-text">
          <h2>Faculty Reviews</h2>
          <p>Select a faculty member to see their detailed ratings or add your own.</p>
        </div>
        <Link to="/add-faculty" className="btn-add-faculty-link">
          + Add Faculty
        </Link>
      </div>
      
      <div className="search-bar-container">
        <input
          type="text"
          placeholder="Search by name or department..."
          className="faculty-search-bar"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {faculty.length === 0 ? (
        <p>No faculty found. Please use the "Add Faculty" page to add one.</p>
      ) : filteredFaculty.length === 0 ? (
        <p className="no-results-text">
          No faculty found matching "{searchTerm}".
        </p>
      ) : (
        <div className="faculty-grid">
          {filteredFaculty.map(prof => (
            <Link to={`/faculty/${prof._id}`} key={prof._id} className="faculty-card">
              <div className="faculty-card-info">
                <h3>{prof.name}</h3>
                <p>{prof.department}</p>
              </div>
              <div className="faculty-card-rating">
                <strong>
                  {typeof prof.overallRating === 'number' 
                    ? prof.overallRating.toFixed(1) 
                    : 'N/A'}
                </strong>
                <span>Overall</span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default FacultyListPage;